import _ from 'lodash'

const WaitlistFormValidator = async (model, waitlistClients)=>{ 

    let errors = {};  
    
    if (_.isEmpty(model.clientType)) {           
        errors.clientType = "Please choose occupant type.";
    }
    if(_.isEqual(model.clientType.code, "CLIENT")){
        if(_.isEmpty(model.client))
            errors.client = "Please choose client.";     
        else if(!_.isNumber(_.get(model, "waitlistAssignmentId"))){
                if(!_.isEmpty(waitlistClients) && !_.isEmpty(_.filter(waitlistClients, (val)=>_.isEqual(_.get(val, "client.id"), model.client.id)))) {
                    errors.client = "Client already in waitlist."; 
                }
            }
    }
    if( _.isEqual(model.clientType.code, "PENDING_CLIENT")){
        if(_.isEmpty(model.pendingClientName))
            errors.pendingClientName = "Please specify pending client name.";

        else if(!_.isNumber(_.get(model, "waitlistAssignmentId"))){
            if(!_.isEmpty(waitlistClients) && !_.isEmpty(_.filter(waitlistClients, (val)=>_.isEqual(_.toUpper(_.get(val, "pendingClientName")), _.toUpper(model.pendingClientName)))))
                errors.pendingClientName = "Client with same name already in waitlist."; 
            }
    }
    if(_.isEmpty(model.priority)){
        errors.priority = "Please choose waitlist priority"
    }
   
    
    return errors;

}

export default WaitlistFormValidator;